// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"30":"c348dbff","728":"d620f50f"}[chunkId] + ".css";
};